import { useCallback, useEffect, useRef, useState } from "react";
import { createElement as h } from "react";
import { useTranslation } from "react-i18next";
import { api } from "./api";
import { Btn } from "../components/kit";

const meta = (r) => ({ total: Number(r.headers["x-total-count"] ?? r.data.length), next: r.headers["x-next-offset"] || "" });

export function usePaged(url, params, limit = 50) {
  const key = JSON.stringify([url, params, limit]);
  const [s, setS] = useState({ items: null, total: 0, next: "", loading: false });
  const seq = useRef(0);
  const load = useCallback((offset) => {
    const n = ++seq.current;
    if (!url) { setS({ items: [], total: 0, next: "", loading: false }); return Promise.resolve(); }
    setS((p) => ({ ...p, loading: true }));
    return api.get(url, { params: { ...params, limit, offset } }).then((r) => {
      if (n !== seq.current) return;
      const m = meta(r);
      setS((p) => ({ items: offset ? [...(p.items || []), ...r.data] : r.data, ...m, loading: false }));
    }).catch(() => n === seq.current && setS((p) => ({ ...p, items: p.items || [], loading: false })));
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setS({ items: null, total: 0, next: "", loading: false }); load(0); }, [load]);
  return { ...s, more: () => load(Number(s.next)), reload: () => load(0) };
}

export async function fetchAll(url, params = {}) {
  let offset = 0, out = [];
  for (;;) {
    const r = await api.get(url, { params: { ...params, limit: 200, offset } });
    out = out.concat(r.data);
    const { next } = meta(r);
    if (!next) return out;
    offset = Number(next);
  }
}

export function useDebounced(value, ms = 250) {
  const [v, setV] = useState(value);
  useEffect(() => { const x = setTimeout(() => setV(value), ms); return () => clearTimeout(x); }, [value, ms]);
  return v;
}

export function LoadMore({ shown, total, onMore, loading, testid }) {
  const { t } = useTranslation();
  if (!total) return null;
  return h("div", { className: "mt-3 flex flex-wrap items-center gap-3 text-sm", "data-testid": `${testid}-pager` },
    h("span", { className: "text-muted-foreground", "data-testid": `${testid}-shown` }, t("p3.showing", { shown, total })),
    shown < total ? h(Btn, { variant: "outline", testid: `${testid}-load-more`, disabled: loading, onClick: onMore }, t("p3.load_more")) : null);
}
